<template>
  <div class="flex items-center justify-center min-h-screen px-4">
    <div
      class="max-w-[500px] w-full shadow-card rounded-xl p-6"
      :class="mode === 'dark' ? 'bg-dark-70' : 'bg-white-100'"
    >
      <div class="mb-5 text-center">
        <span class="text-lg font-bold leading-none" v-if="isTeamSignup"
          >You've been invited to join the team associated with the email
          address {{ invitedBy }}</span
        >
        <span class="text-lg font-bold leading-none" v-else
          >Try FREE for 14 Days! NO Credit Card Needed</span
        >
      </div>
      <div class="grid gap-6 mb-5">
        <SignInWithGoogleButton :mode="mode" />
        <div
          class="border-b relative flex items-center justify-center"
          :class="mode === 'dark' ? 'border-dark-50' : ''"
        >
          <span
            class="absolute w-10 h-10 rounded-full flex items-center justify-center z-10"
            :class="mode === 'dark' ? 'bg-dark-70' : 'bg-white-100'"
            >OR</span
          >
        </div>
      </div>
      <div class="grid gap-4">
        <div v-if="!isTeamSignup" class="relative">
          <label for="current-email" class="text-[15px] mb-1 block"
            >Email address</label
          >
          <input
            type="text"
            class="form-field pl-9"
            placeholder="example@site.com"
            v-model="email"
          />
          <div
            class="absolute bottom-0 left-2.5 flex h-11 items-center text-gray-0 text-opacity-70"
          >
            <AtSign :size="20" :stroke-width="1.75" />
          </div>
        </div>
        <div class="relative">
          <label for="old-pass" class="text-[15px] mb-1 block">Password</label>
          <input
            :type="[isPassword ? 'text' : 'password']"
            class="form-field pl-9"
            placeholder="Enter password"
            v-model="password1"
          />
          <div
            class="absolute bottom-0 left-2.5 flex h-11 items-center text-gray-0 text-opacity-70"
          >
            <LockKeyhole :size="20" :stroke-width="1.75" />
          </div>
          <div
            class="absolute bottom-0 right-4 flex h-11 items-center cursor-pointer"
          >
            <span
              @click="isPassword = !isPassword"
              class="text-primary-100 text-sm hover:underline hover:decoration-dashed"
              >{{ isPassword ? "Hide" : "Show" }}</span
            >
          </div>
        </div>
        <div class="relative">
          <label for="confirm-new-pass" class="text-[15px] mb-1 block"
            >Confirm password</label
          >
          <input
            :type="[isPasswordConfirm ? 'text' : 'password']"
            class="form-field pl-9"
            placeholder="Confirm password"
            v-model="password2"
          />
          <div
            class="absolute bottom-0 left-2.5 flex h-11 items-center text-gray-0 text-opacity-70"
          >
            <LockKeyhole :size="20" :stroke-width="1.75" />
          </div>
          <div
            @click="isPasswordConfirm = !isPasswordConfirm"
            class="absolute bottom-0 right-4 flex h-11 items-center cursor-pointer"
          >
            <span
              class="text-primary-100 text-sm hover:underline hover:decoration-dashed"
              >{{ isPasswordConfirm ? "Hide" : "Show" }}</span
            >
          </div>
        </div>
        <button class="button primary-button" @click="signUp">
          {{
            isTeamSignup
              ? "Accept Invitation and Create Account"
              : " Try it yourself! Free for 14 days (NO Credit Card Needed)"
          }}
        </button>
        <div class="text-center text-[15px]">
          Have an account ?
          <RouterLink
            v-if="redirectUrl"
            :to="{
              name: 'signin',
              query: {
                ...(redirectUrl ? { redirectUrl: redirectUrl } : {}),
              },
            }"
            class="hover:text-primary-100"
            >Sign in</RouterLink
          >
          <RouterLink
            v-else
            :to="{
              name: 'signin',
              query: {
                ...($route.query?.redirectUrl
                  ? { redirectUrl: $route.query.redirectUrl }
                  : {}),
              },
            }"
            class="hover:text-primary-100"
            >Sign in</RouterLink
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import helper from "../libs/helper";
import { useUserStore } from "../stores/user";
import ApiRequest from "../libs/ApiRequest";
import SignInWithGoogleButton from "../components/common/SignInWithGoogleButton.vue";
import { AtSign, LockKeyhole } from "lucide-vue-next";
export default {
  setup() {
    return {
      userStore: useUserStore(),
    };
  },
  props: {
    mode: String,
  },
  components: {
    SignInWithGoogleButton,
    AtSign,
    LockKeyhole,
  },
  data() {
    return {
      email: "",
      password1: "",
      password2: "",
      isTeamSignup: false,
      invitedBy: "",
      isPassword: false,
      isPasswordConfirm: false,
      redirectUrl: null,
    };
  },
  mounted() {
    if (this.$route.name === "team-signup") {
      this.invitedBy = this.$route?.query?.invited_by || "";
      this.isTeamSignup = true;
    }
    if (this.$route.query && this.$route.query.hasOwnProperty("plan")) {
      const planParam = this.$route.query["plan"].split("_")[0];
      const tierParam = this.$route.query["plan"].split("_")[1];
      window.localStorage.setItem(
        "seo-plan",
        "plan=" + planParam + "_" + tierParam
      );
      this.redirectUrl =
        "/payments/order?plan=" +
        planParam +
        "_" +
        tierParam +
        "&coupon=s3oArph3";
    }
  },
  methods: {
    async signUp() {
      try {
        this.userStore.setIsLoading(!0);
        if (!this.password1) {
          throw new Error("Password can't be empty");
        }
        if (this.password1 !== this.password2) {
          throw new Error("Password & Confirm Password must match!");
        }
        const postData = {
          first_name: "",
          last_name: "",
          password: this.password1,
          password2: this.password2,
        };
        let response;
        if (this.$route.name === "team-signup") {
          const inviteUUID = this.$route.params.uuid;
          if (!inviteUUID) {
            throw new Error("Invalid invite code!");
          }
          response = await ApiRequest().put(
            `/api/auth/team/signup/${inviteUUID}`,
            postData
          );
        } else {
          if (!this.email) {
            throw new Error("Email can't be empty");
          }
          const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          if (!emailPattern.test(this.email)) {
            throw new Error("Email is invalid");
          }
          postData.email = this.email;
          response = await ApiRequest("skip").post(
            `/api/auth/signup`,
            postData
          );
        }
        if (response.status === 201 || response.status === 200) {
          this.$toast.success(
            "Verify your email to gain full access. Check your inbox (including spam) for the activation link!"
          );
          this.email = "";
          this.password1 = "";
          this.password2 = "";
          if (this.redirectUrl) {
            this.$router.push({
              name: "success-signup",
              query: {
                ...(this.redirectUrl ? { redirectUrl: this.redirectUrl } : {}),
              },
            });
          } else {
            this.$router.push({
              name: "success-signup",
              query: {
                ...(this.$route.query?.redirectUrl
                  ? { redirectUrl: this.$route.query.redirectUrl }
                  : {}),
              },
            });
          }
        }
        this.userStore.setIsLoading(!1);
      } catch (error) {
        this.userStore.setIsLoading(!1);
        const extractedError = helper.extractAlert(error, "signup");
        this.$toast.error(extractedError.alert.message);
      }
    },
  },
};
</script>
